export default __webpack_public_path__ + "static/media/pharrell3.49ffb887.jpeg";